import classNames from "classnames";
import { isNumber } from "lodash";
import React from "react";

import { formatNumber } from "../../utils/utils";
import css from "./box_renderer.module.scss";
import BoxTooltip from "./box_tooltip";
import DeltaArrow from "./delta_arrow";
import Tile from "./tile";

export type BoxItem = {
  title: string[] | string;
  value: string | number;
  tooltip?: string;
  delta?: number;
  big?: boolean;
};

type BoxRendererProps = {
  boxItem: BoxItem[];
};

const BoxRenderer = ({ boxItem }: BoxRendererProps): JSX.Element => {
  const hasTooltip = boxItem.filter(({ tooltip }) => tooltip);

  return (
    <div
      className={classNames({
        [css.rolesDemandFirstRow]: hasTooltip,
        [css.rolesDemandSecondRow]: !hasTooltip
      })}
    >
      {boxItem.map(({ title, value, tooltip, delta, big }, index) => (
        <Tile className={css.rolesDemandBox} key={`${title}-${index}`}>
          <h2>{title}</h2>
          <p className={classNames({ [css.rolesDemandBigValue]: big, [css.rolesDemandValue]: !big })}>
            {isNumber(value) ? formatNumber(value?.toFixed(0)) : value}
          </p>
          {tooltip && <BoxTooltip content={tooltip} />}
          {isNumber(delta) && <DeltaArrow delta={delta} />}
        </Tile>
      ))}
    </div>
  );
};

export default BoxRenderer;
